import React, { FunctionComponent, ReactNode } from "react";
import { IonLabel, IonList, IonListHeader, IonNote, IonGrid, IonRow, IonCol, IonIcon } from "@ionic/react";
import { chevronForward } from "ionicons/icons";
import { useHistory } from "react-router-dom";

export const EditIonCardSiteList: FunctionComponent<{
  title: string;
  subtitle?: ReactNode;
  list: {
    id: string;
    name: string;
    icon?: string,
    numberOfAnnotations: number,
    isGraphic?: boolean,
    isExported: boolean,
    numberOfExportedBuildings: number,
    numberOfBuildings: number,
  }[];
  itemChild: (item: any) => ReactNode;
  getRouterLink: (id: string) => string;
}> = ({
  title,
  subtitle,
  list,
  itemChild,
  getRouterLink
}) => {
  const history = useHistory();

  const handleClick = (id: string) => {
    history.push(getRouterLink(id));
  };

  return (
    <IonList className={title ? "ion-padding-16 ion-padding-lg-24" : ""}>
      {title && (
        <IonListHeader>
          <IonLabel style={{ marginTop: 0, fontSize: 16 }}>{title}</IonLabel>
        </IonListHeader>
      )}
      {subtitle && <IonNote style={{ paddingLeft: 20, fontSize: 14 }}>{subtitle}</IonNote>}
      <IonGrid>
        <IonRow>
          {list.map((item) => (
            <IonCol size="12" sizeLg="3" key={item.id}>
              <div 
                onClick={() => handleClick(item.id)}
                style={{
                  backgroundColor: '#FFFFFF',
                  borderRadius: '6px',
                  padding: '0',
                  margin: '8px',
                  boxShadow: '1px 1px 3px 0px var(--elevation-xs, rgba(0, 0, 0, 0.20))',
                  cursor: 'pointer',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'stretch',
                  minHeight: '85px'
                }}
              >
                <IonIcon 
                  icon={chevronForward} 
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#4B4D56',
                    zIndex: 10
                  }}
                />
                {itemChild(item)}
              </div>
            </IonCol>
          ))}
        </IonRow>
      </IonGrid>
    </IonList>
  );
}; 
